import { ColDef } from "ag-grid-community";

export const regionColumnDef: ColDef = {
  field: "resource.region",
  headerName: "Region",
};
